import {isString} from './isString'

export const isCardanoAddress = (address: string) =>
  isString(address) && /^[A-Za-z_0-9]+$/.test(address)
